import ExcelJS from "exceljs";
import dayjs from "dayjs";

export async function exportAdviserStatusExcel(advisers = []) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Rosemount Staff Portal";
  workbook.created = new Date();

  const worksheet = workbook.addWorksheet("Adviser Status", {
    views: [{ state: "frozen", ySplit: 1 }],
  });
  worksheet.columns = [
    { header: "ADVISER NAME", key: "name", width: 36 },
    { header: "APPOINTMENT STATUS", key: "appointmentStatus", width: 24 },
    { header: "STATUS", key: "status", width: 44 },
    { header: "EMAIL", key: "email", width: 40 },
  ];

  const asOf = dayjs();
  advisers
    .map((adviser) => {
      const firstName = adviser?.preferredName || adviser?.firstName || "";
      const name = [firstName, adviser?.lastName].filter(Boolean).join(" ").trim();
      return {
        name: name || adviser?.email || adviser?.id || "",
        appointmentStatus: adviser?.isAppointed === false ? "Unappointed / Leaver" : "Appointed",
        status: (Array.isArray(adviser?.status) ? adviser.status : [adviser?.status]).filter(Boolean).join(", "),
        email: adviser?.email || "",
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }))
    .forEach((row) => worksheet.addRow(row));

  worksheet.autoFilter = "A1:D1";
  worksheet.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
  worksheet.getRow(1).fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF081E56" },
  };
  worksheet.getRow(1).alignment = { vertical: "middle", horizontal: "center" };
  worksheet.getRow(1).border = {
    bottom: { style: "medium", color: { argb: "FF9EB25D" } },
  };
  worksheet.getRow(1).height = 26;
  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber > 1 && rowNumber % 2 === 0) {
      row.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE9EBF8" },
      };
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();
  return {
    blob: new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    filename: `Adviser Status - ${asOf.format("DD-MM-YYYY")}.xlsx`,
  };
}

